import React from 'react'
import { SingleVisitImg}  from '../../../../../images/index'

const SINGLE_VISIT_STYLE= {
  top: "52%",
  transform: "translateY(-50%)",
  left:"40vw",
  maxWidth:"20vw"
}

function SingleVisitSlider() {
  
  return (
    <div className="relative bg-gradient-to-t from-black via-blue-500 to-black">
      <img
        alt="single-visit"
        src={SingleVisitImg}
        className="z-0 object-contain h-screen w-screen px-10 xl:px-16"
      />
      <div
        className={`flex flex-col justify-between align-middle text-left m-2 absolute inset-0 z-20 pt-10 xl:pt-8`}
        style={SINGLE_VISIT_STYLE}
      >
        <div className="flex flex-col mb-2">
          <h1 className="text-left text-white text-2xl xl:text-3xl font-bold mb-2">
            Single Visit Dentistry by XiViX
          </h1>
          <div className={` font-sans text-white`}>
            <h2 className="mb-6 text-xl font-semibold">Simply Prep&Place*</h2>
            <ul>
              <li className="my-1">
                <span className="text-white text-base font-extrabold mr-1">
                  &#x2022;
                </span>
                optimized AI prep-assistance
              </li>
              <li className="my-1">
                <span className="text-white text-base font-extrabold mr-1">
                  &#x2022;
                </span>
                no messy impressions
              </li>
              <li className="my-1">
                <span className="text-white text-base font-extrabold mr-1">
                  &#x2022;
                </span>
                no metal fillings
              </li>
              <li className="my-1">
                <span className="text-white text-base font-extrabold mr-1">
                  &#x2022;
                </span>
                no temporaries
              </li>
              <li className="my-1">
                <span className="text-white text-base font-extrabold mr-1">
                  &#x2022;
                </span>
                optimized fit
              </li>
              <li className="my-1">
                <span className="text-white text-base font-extrabold mr-1">
                  &#x2022;
                </span>
                long lasting restorations
              </li>
            </ul>
          </div>
        </div>
      </div>
      <p className="absolute mt-10 text-base bottom-4 right-4 text-white">
        *For inlays overlays, crowns & veneers.
      </p>
    </div>
  );
}

export default SingleVisitSlider
